// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3360d486","977":"e8ba42c6"}[chunkId] + ".chunk.js";
};